import type { MiddlewareFactory } from '../../middlewares/types';
import type { AuthProvider } from './types';

const createLocalAuthenticationMiddleware = (): MiddlewareFactory => {
  return (next) => {
    return (req, event) => next(req, event);
  };
};

export const localAuthProvider: AuthProvider = {
  type: 'local',
  getSessionToken: () => null,
  createAuthenticationMiddleware: createLocalAuthenticationMiddleware,
};
